import { render } from "./FirsttimerReport.vue?vue&type=template&id=5027d957&scoped=true"
import script from "./FirsttimerReport.vue?vue&type=script&lang=js"
export * from "./FirsttimerReport.vue?vue&type=script&lang=js"

import "./FirsttimerReport.vue?vue&type=style&index=0&id=5027d957&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5027d957"]])

export default __exports__